<template>
  <div>
    <app-cells><h1 class="title">Flight reservations</h1></app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view  />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'FlightsReservationsListLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'reservation-flights-list', label: 'Active' },
        { name: 'reservation-flights-list-archive', label: 'Archive' },
        { name: 'reservation-flights-list-cancelled', label: 'Cancelled' },
      ],
    }
  },
}
</script>
